// tax-exemption.js - basic client validation & file checks
document.addEventListener('DOMContentLoaded', function () {
  const form = document.getElementById('tax-exemption-form');
  if (!form) return;

  const MAX_FILE_BYTES = 5 * 1024 * 1024; // 5MB
  const ALLOWED_TYPES = ['application/pdf', 'image/jpeg', 'image/png'];

  function showError(field, message) {
    const container = field.closest('.tax-exemption__field');
    if (!container) return;
    let err = container.querySelector('.field-error');
    if (!err) {
      err = document.createElement('div');
      err.className = 'field-error';
      err.style.color = '#c0392b';
      err.style.marginTop = '6px';
      err.style.fontSize = '0.9rem';
      container.appendChild(err);
    }
    err.textContent = message;
    err.style.display = 'block';
    field.setAttribute('aria-invalid', 'true');
  }

  function clearError(field) {
    const container = field.closest('.tax-exemption__field');
    if (!container) return;
    const err = container.querySelector('.field-error');
    if (err) { err.textContent = ''; err.style.display = 'none'; }
    field.removeAttribute('aria-invalid');
  }

  form.addEventListener('input', function (e) {
    if (e.target && e.target.closest('.tax-exemption__field')) clearError(e.target);
  });

  form.addEventListener('submit', function (evt) {
    let valid = true;
    const required = form.querySelectorAll('[required]');

    required.forEach(function (el) {
      clearError(el);
      if (el.type === 'file') {
        if (!el.files || el.files.length === 0) {
          showError(el, 'This field is required.');
          valid = false;
        }
      } else if (!String(el.value || '').trim()) {
        showError(el, 'This field is required.');
        valid = false;
      }
    });

    const fileInput = form.querySelector('input[type="file"][name="certificate"]');
    if (fileInput && fileInput.files.length > 0) {
      const f = fileInput.files[0];
      if (ALLOWED_TYPES.indexOf(f.type) < 0) {
        showError(fileInput, 'Invalid file type. Allowed: PDF, JPG, PNG.');
        valid = false;
      } else if (f.size > MAX_FILE_BYTES) {
        showError(fileInput, 'File is too large. Max 5 MB.');
        valid = false;
      }
    }

    if (!valid) {
      evt.preventDefault();
      const first = form.querySelector('.field-error[style*="block"], [aria-invalid="true"]');
      if (first) first.scrollIntoView({ behavior: 'smooth', block: 'center' });
    } else {
      // allow natural submit to server endpoint
    }
  });
});
